(()=>{
let isActive = true;
let startTime;
let totalTime = 0;

let isActiveSession = false;

function startTrackingTime() {
  isActive = true;
  startTime = Date.now();
  trackTime();
}

function stopTrackingTime() {
  isActive = false;
  totalTime += Date.now() - startTime;
}

function trackTime() {
  if (isActive) {
    totalTime += Date.now() - startTime;
    startTime = Date.now();
  }
}

startTrackingTime();

document.addEventListener("visibilitychange", function() {
  if (document.visibilityState === 'hidden') {
    stopTrackingTime();
  } else {
    startTrackingTime();
  }
});

window.addEventListener("blur", () => stopTrackingTime());

window.addEventListener("focus", () => startTrackingTime());

window.setInterval(() => trackTime(), 1000);

window.addEventListener("scroll", () => { isActiveSession = true }, { once: true, passive: true });
window.addEventListener("click", () => { isActiveSession = true }, { once: true, passive: true });
window.addEventListener("pointerdown", () => { isActiveSession = true }, { once: true, passive: true });

window.addEventListener("beforeunload", function() {
  stopTrackingTime();
  window['ablyft'] = window['ablyft'] || [];
  window['ablyft'].push({
      eventType: 'custom',
      eventName: 'sitzungsdauer',
      eventValue: totalTime / 1000 //optional
  });
  
  if(totalTime < 10 * 1000 || !isActiveSession){
    window['ablyft'].push({
        eventType: 'custom',
        eventName: 'absprungrate',
        eventValue: 0 //optional
    });
  }
});
})()